import React from "react"
import Layout from "../components/layout"
import "../css/careers.css"
import Nav from "../components/nav"
import ActOnNew from "../components/act-on/act-on-new"
import officePhoto from "../images/IMG_1233.jpg"
import SEO from "../components/seo.js"

function jobScript () {
  return new Promise ((resolve, reject) => {
    var jobScript = document.createElement("script")

    var text = `
    (function(d, s, c) {
      if (window._jobscore_loader) { return; } else { window._jobscore_loader = true; }
      var o = d.createElement(s); o.type = 'text/javascript'; o.async = true;
      var sc = d.getElementsByTagName(s)[0]; sc.parentNode.insertBefore(o, sc);
      o.src = ('https:' == d.location.protocol ? 'https:' : 'http:') + '//widgets.jobscore.com/jobs/' + c + '/widget.js';
    })(document, 'script', 'circadencecorporation');`

    jobScript.text = text;
    jobScript.addEventListener("load", function () {
      console.log("jobscript loaded");
      resolve()
    })
    jobScript.addEventListener("error", function (e) {
      console.log("jobscript error", e);
      reject(e)
    })
    document.body.appendChild(jobScript)
  })
}

class Jobs extends React.Component {

  constructor(props) {
    super(props)

    this.state = {

    }
  }

  componentWillMount() {
    jobScript()
  }

  render () {
    return (
      <Layout>
        <SEO title="Careers | Cybersecurity Jobs" description="Find the job that's right for you with Circadence, the market leader in cybersecurity learning and assessment solutions. "/>

        <div className="mainContainer gray">
          <div id="jobs-header" className="centeredContainer" style={{alignItems: "center", padding: "30px"}}>
            <iframe width="560" height="315" src="https://www.youtube.com/embed/GNWvWXoIVnU" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            <div className="c-header-text">
              <h2>Careers</h2>
              <p>Circadence is a fast-paced, challenging, and results oriented company that strives to  meet the changing education needs of the cyber security industry.  Our workplace culture is adaptable, respectful, and friendly with over 125 employees and growing  across 4 locations plus a core remote workforce.
                <br/>
                <br/>
                Circadence acknowledges each person’s unique story and employs a diverse group of individuals who function cohesively and enthusiastically to create innovative solutions. We believe in collaboration, an all-hands-on-deck approach, and in the power of individual strengths to guide the collective output.  We are proud to be an Equal Opportunity/Affirmative Action employer.
              </p>
            </div>
          </div>
        </div>
        <div className="mainContainer">
          <div className="centeredContainer wrap">
            <h3 style={{flexBasis: "100%", marginBottom: 30, marginTop: 30}}>Find Open Roles</h3>
            <div id="jobswrapper" class="jobswrapper">
              <div class='jobscore-jobs' data-font-family='Roboto' data-font-size='16px' data-link-text-color='#333333' data-group-by='department' >
                <div class='js-fallback'>
                  <a href='https://careers.jobscore.com/jobs/circadencecorporation'>Circadence Corporation jobs</a> powered by <a href='https://www.jobscore.com/'>
                    <img align='bottom' src='https://careers.jobscore.com/images/new/jobscore_logo_embed.png' alt='Applicant Tracking, Social Recruiting and Software Hiring Solution - JobScore'></img>
                  </a>
                </div>
              </div>
            </div>
            <a href="https://careers.jobscore.com/careers/circadencecorporation" target="__blank" style={{margin: "20px auto"}}>
              <button className="flat-button">Browse all current job opportunities</button>
            </a>
          </div>
        </div>
        <div className="mainContainer">
          <div id="career-statements" className="centeredContainer wrap">
            <h4 style={{color: "var(--deep-blue)", marginTop: 20}}>Diversity Statement:</h4>
            <p>Circadence understands that diversity is a major competitive advantage and values the differences among its employees. We are proud to be an Equal Opportunity/Affirmative Action employer. All qualified applicants will receive consideration for employment without regard to race, color, religion, sex including sexual orientation and gender identity, national origin, disability, protected Veteran Status, or any other characteristic protected by applicable federal, state, or local law.
            <br/>
            <br/>
            If you are a qualified individual with a disability or a disabled veteran, you have the right to request an accommodation. To request an accommodation, contact our Human Resources Department at recruiter@circadence.com.</p>
            <h4 style={{color: "var(--deep-blue)", marginTop: 20}}>Equal Employment Opportunity Statement:</h4>
            <p>Circadence is an equal opportunity employer. In accordance with applicable law, we prohibit discrimination against any applicant or employee based on any legally-recognized basis, including, but not limited to: race, color, religion, sex (including pregnancy, lactation, childbirth or related medical conditions), sexual orientation, gender identity, age (40 and over), national origin or ancestry, physical or mental disability, genetic information (including testing and characteristics), veteran status, uniformed service member status or any other status protected by federal, state or local law. The Company also makes employment decisions such as recruiting, hiring, training, promoting employees based on the aforementioned characteristics.  Our commitment to equal opportunity employment applies to all persons involved in our operations and prohibits unlawful discrimination by any employee, including supervisors and co-workers.
            </p>
            <h4 style={{color: "var(--deep-blue)", marginTop: 20}}>Note to Recruitment Agencies:</h4>
            <p>Circadence’s Human Resources Department is solely responsible for all recruitment activities. As such, Circadence is not responsible for any fees resulting from resumes submitted by recruitment agencies having no written and signed agreement in place with our company. Circadence will only pay a fee to agencies once a formal agreement between our company and the agency is established and a candidate is hired.
            </p>
          </div>
        </div>
        <div className="mainContainer yellow" style={{marginTop: 30}}>
          <div id="jobs-about" className="centeredContainer">
            <h4>Working at Circadence</h4>
            <p>Circadence is a dynamic company committed to cyber education and training. We help novice and seasoned cyber security professionals embrace a new way to train in cyber security. Through our learning solutions,  individuals and teams can develop competencies with hands-on training exercises that improve critical thinking against real-world adversaries.
            <br/>
            <br/>
            To deliver on this mission, our functional teams collaborate and coordinate with each other to build and market solutions that best serve the needs of our clients.  And we serve the needs of our team members, many of whom work remotely, with tools to safely engage and collaborate online.  </p>
          </div>
        </div>
        <div className="mainContainer bright-blue">
          <div id="jobs-join" className="centeredContainer wrap">
            <div className="jj-left">
              <div class="jj-image-container">
                <img src={officePhoto} alt="Circadence Boulder office"/>
              </div>
              <h4 style={{color: "white"}}>Join Our Team</h4>
              <p>Contact <a href="mailto:recruiter@circadence.com">recruiter@circadence.com</a> if you have any questions or would prefer to apply through email.</p>
            </div>
            <div className="jj-right">
              <ActOnNew id="5b5da43b-7d97-4138-998b-31c776d4eab6"/>
            </div>
          </div>
        </div>
      </Layout>
    )
  }
}

// AO form id: 5b5da43b-7d97-4138-998b-31c776d4eab6

export default Jobs
